/**
 * @generated SignedSource<<72b40fc21bfbccc64e9dbcce151b80a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfirmationStatusIntention = "CONFIRMED" | "REJECTED" | "DEFERRED" | "%future added value";
export type ContractConfirmationActionsMutation$variables = {
  contractId: string;
  status: ConfirmationStatusIntention;
};
export type ContractConfirmationActionsMutation$data = {
  readonly updateContractConfirmationStatus: {
    readonly messageId: string;
  } | null;
};
export type ContractConfirmationActionsMutation = {
  variables: ContractConfirmationActionsMutation$variables;
  response: ContractConfirmationActionsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "confirmationStatus",
        "variableName": "status"
      },
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      }
    ],
    "concreteType": "UpdateContractConfirmationStatusPayload",
    "kind": "LinkedField",
    "name": "updateContractConfirmationStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "messageId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContractConfirmationActionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContractConfirmationActionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9175c8a8cb35c55d5865c8b670af1eeb",
    "id": null,
    "metadata": {},
    "name": "ContractConfirmationActionsMutation",
    "operationKind": "mutation",
    "text": "mutation ContractConfirmationActionsMutation(\n  $contractId: GUID!\n  $status: ConfirmationStatusIntention!\n) {\n  updateContractConfirmationStatus(contractId: $contractId, confirmationStatus: $status) {\n    messageId\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea2bf2ecd7b9e25d85063c10cebd9618";

export default node;
